"use client";

import { Box } from "@chakra-ui/react";
import { StudioIndexHitsProvider } from "../contexts/StudioIndexHitsContext";
import StudioActionBars from "../views/StudioActionBars";
import StudioWorkspaceView from "../views/StudioWorkspaceView";
import StudioChrome from "./StudioChrome";
import useStudioScreen from "./useStudioScreen";

function StudioScreen() {
  const screen = useStudioScreen();

  return (
    <Box position="relative">
      <StudioChrome screen={screen} selectionActions={<StudioActionBars />}>
        <StudioWorkspaceView />
      </StudioChrome>
    </Box>
  );
}

export default function Studio() {
  return (
    <StudioIndexHitsProvider>
      <StudioScreen />
    </StudioIndexHitsProvider>
  );
}
